import React from 'react'
import Skeleton from 'react-loading-skeleton'
import { PropTypes } from 'prop-types'

const VegaTypo = ({ className, label, title = false, width }) => {
	return (
		<span className={className} title={title ? (title === true ? label : title) : ''}>
			{label || <Skeleton width={width} />}
		</span>
	)
}

VegaTypo.propTypes = {
	/** Allow to set a classname on the component */
	className: PropTypes.string,
	/** Text of the component */
	label: PropTypes.string,
	/** Optional size in px of placeholder, by default, it grows as big as it can */
	width: PropTypes.number
}

export { VegaTypo }
